import { EmailIcon } from "@chakra-ui/icons";
import {
  Button,
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useColorMode,
  useDisclosure,
} from "@chakra-ui/react";

export default function SubstackModal2() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { colorMode } = useColorMode();
  const backgroundColor = colorMode === "light" ? "white" : "white";

  return (
    <>
      <Center>
        <Center mt={5}>
          <Button
            onClick={onOpen}
            variant="outline"
            paddingX={5}
            paddingY={5}
            margin={8}
            borderRadius={20}
            borderStyle="solid"
            borderColor={"rgba(255,102,196,0.9)"}
            borderWidth={1}
            colorScheme="black"
            boxShadow="md"
          >
            <Text>
              <EmailIcon mr={3} mb={"1px"} />
              Don{`'`}t miss a beat
            </Text>
          </Button>
        </Center>
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent backgroundColor={backgroundColor}>
            <ModalCloseButton
              top={3}
              right={3}
              color="black"
              _focus={{ boxShadow: "none" }}
              _focusVisible={{ boxShadow: "none" }}
              _active={{ boxShadow: "none" }}
            />

            <ModalBody>
              <Center>
                <iframe
                  src="https://songcards.substack.com/embed"
                  width="100%"
                  height={320}
                ></iframe>
              </Center>
            </ModalBody>
          </ModalContent>
        </Modal>
      </Center>
    </>
  );
}
